var map = {
	"./wave_1.svg": 5699,
	"./wave_10.svg": 2056,
	"./wave_11.svg": 8819,
	"./wave_12.svg": 3600,
	"./wave_13.svg": 6594,
	"./wave_14.svg": 9558,
	"./wave_15.svg": 3590,
	"./wave_2.svg": 6798,
	"./wave_3.svg": 4400,
	"./wave_4.svg": 7897,
	"./wave_5.svg": 2356,
	"./wave_6.svg": 1467,
	"./wave_7.svg": 2069,
	"./wave_8.svg": 2740,
	"./wave_9.svg": 1478
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8580;